<script>
import { parse, format } from 'date-fns'

export default {
  name: 'OverrideCard',
  props: {
    override: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return this.override.override_date
    },
    timeRange() {
      if (!this.override.start_time && !this.override.end_time) {
        return 'Closed (Full Day)';
      }
      return `${this.formatTime(this.override.start_time) || '-'} - ${this.formatTime(this.override.end_time) || '-'}`;
    },
  },
  methods: {
    handleEdit() {
      this.$emit('edit', this.override);
    },
    handleDelete() {
      this.$emit('delete', { 
        id: this.override.id, 
        name: this.formattedDate 
      });
    },
    formatTime(timeString) {
      if (!timeString) return ''

      const [hour, minute] = timeString.split(':')
      const h = Number(hour)
      const ampm = h >= 12 ? 'pm' : 'am'
      const formattedHour = h % 12 || 12

      return `${formattedHour}:${minute}${ampm}`
    },
  },
};
</script>

<template>
  <div class="border border-slate-200 dark:border-slate-600 rounded-lg p-4 mb-3 hover:shadow-md transition-shadow bg-white dark:bg-slate-800">
    <div class="flex justify-between items-start">
      <div class="flex-1">
        <h3 class="text-base font-semibold text-slate-900 dark:text-white mb-1">
          {{ formattedDate }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-300">
          {{ timeRange }}
        </p>
        <p v-if="override.reason" class="text-sm text-slate-500 dark:text-slate-400 mt-2">
          {{ override.reason }}
        </p>
      </div>
      <div class="flex gap-2">
        <woot-button
          variant="smooth"
          color-scheme="secondary"
          icon="edit"
          size="small"
          @click="handleEdit"
        />
        <woot-button
          variant="smooth"
          color-scheme="alert"
          icon="delete"
          size="small"
          @click="handleDelete"
        />
      </div>
    </div>
  </div>
</template>
